import React from 'react';
import { YlmToggle } from '../../../../components/forms/YlmToggle';
import {
  INTERRUPTOR_FACTOR_RIESGO,
  INTERRUPTOR_PAGO_ADELANTADO,
  MAXIMO_DIGITOS_DIAS_PREPAGO,
  esEntradaDiasValida,
  estaInterruptorActivo,
  interruptorBloqueado,
  normalizarDias,
} from '../../../../helpers/interruptoresPrepago';

const InputDias = ({ valor, deshabilitado, cambiarValor }) => (
  <input
    type='text'
    inputMode='numeric'
    pattern='[0-9]*'
    maxLength={ MAXIMO_DIGITOS_DIAS_PREPAGO }
    className='config-input-inline'
    value={ valor ?? '' }
    disabled={ deshabilitado }
    onChange={ (evento) => cambiarValor( evento.target.value ) }
  />
);

const FilaInterruptor = ({ interruptor, titulo, activo, bloqueado, cambiarInterruptor, colores, children }) => (
  <div className={ `interruptor-prepago ${ activo ? '' : 'apagado' }` }>
    <YlmToggle
      item={{ _id: interruptor, active: activo, text: titulo }}
      clickToggle={ cambiarInterruptor }
      color={ colores.colorPrincipal }
      bgColor={ colores.colorSecundario }
      disabled={ bloqueado }
    />
    <h5 className='interruptor-regla'>{ children }</h5>
    {
      bloqueado &&
      <p className='interruptor-ayuda'>Debe quedar activo al menos uno de los dos.</p>
    }
  </div>
);

export const PagoAdelantado = ({ objEmpresa, setObjEmpresa, colores }) => {
  const pagoAdelantadoActivo = estaInterruptorActivo(objEmpresa, INTERRUPTOR_PAGO_ADELANTADO);
  const factorRiesgoActivo = estaInterruptorActivo(objEmpresa, INTERRUPTOR_FACTOR_RIESGO);
  const interruptorQueNoSePuedeApagar = interruptorBloqueado(objEmpresa);

  const cambiarInterruptor = (interruptor) => {
    const estabaActivo = estaInterruptorActivo(objEmpresa, interruptor);
    setObjEmpresa({ ...objEmpresa, [interruptor]: !estabaActivo });
  };

  const cambiarDias = (campo, textoTecleado) => {
    if (!esEntradaDiasValida(textoTecleado)) return;
    setObjEmpresa({ ...objEmpresa, [campo]: normalizarDias(textoTecleado) ?? '' });
  };

  return (
    <div className='section pago-adelantado'>
      <h3 style={{ color: colores.colorSecundario }}>Pago por adelantado</h3>
      <h5>
        Los servicios marcados como Prepago y los clientes marcados con Pago por adelantado en su
        ficha pagan siempre al reservar, con cualquier combinación de estos dos interruptores.
      </h5>
      <div className='interruptores-prepago'>
        <FilaInterruptor
          interruptor={ INTERRUPTOR_PAGO_ADELANTADO }
          titulo='Pago por adelantado'
          activo={ pagoAdelantadoActivo }
          bloqueado={ interruptorQueNoSePuedeApagar === INTERRUPTOR_PAGO_ADELANTADO }
          cambiarInterruptor={ cambiarInterruptor }
          colores={ colores }
        >
          Quien reserve con más de
          <InputDias
            valor={ objEmpresa.diasPrepago }
            deshabilitado={ !pagoAdelantadoActivo }
            cambiarValor={ (texto) => cambiarDias('diasPrepago', texto) }
          />
          días de antelación paga por adelantado. Con 0 días, paga toda reserva que no sea para hoy.
          Si Factor riesgo también está activo, los clientes en ámbar y en rojo se rigen por Factor
          riesgo y estos días se aplican a los clientes en verde.
        </FilaInterruptor>
        <FilaInterruptor
          interruptor={ INTERRUPTOR_FACTOR_RIESGO }
          titulo='Factor riesgo'
          activo={ factorRiesgoActivo }
          bloqueado={ interruptorQueNoSePuedeApagar === INTERRUPTOR_FACTOR_RIESGO }
          cambiarInterruptor={ cambiarInterruptor }
          colores={ colores }
        >
          Los clientes en rojo (factor de riesgo 50 o más) pagan siempre por adelantado. Los clientes
          en ámbar (entre 25 y 49) pagan si ya tienen otra cita futura reservada o si reservan con más de
          <InputDias
            valor={ objEmpresa.diasAntelacionPagoFactorRiesgo }
            deshabilitado={ !factorRiesgoActivo }
            cambiarValor={ (texto) => cambiarDias('diasAntelacionPagoFactorRiesgo', texto) }
          />
          días de antelación. Los clientes en verde (menos de 25) no pagan por esta regla: solo por los
          días de Pago por adelantado, si está activo.
        </FilaInterruptor>
      </div>
    </div>
  );
};
